const { useState } = require("react");
export const EventCard = ({
  title,
  venue,
  location,
  date,
  time,
  onRSVP,
  category = "Event",
  capacity = "100",
  attendees = "65",
  imageUrl,
  imageAlt,
}) => {


  return (
    <div className="transition-all duration-300 max-w-[300px]transform hover:translate-y-[-2px] rounded-2xl  " style={{ 'backgroundColor': '#e2e8f0'}} >
    <div className="relative">
      <div className="aspect-w-16 aspect-h-9 rounded-lg ">
        <img
          src={imageUrl || "/placeholder-event.jpg"}
          alt={imageAlt || title}
          className="w-full rounded-lg bg-white object-cover group-hover:opacity-75 max-sm:h-80 sm:aspect-2/1 lg:aspect-square"
        />
      </div>
      <div className="absolute top-4 left-4">
        <span className="text-sm font-small px-4 py-1.5 bg-white/95 text-blue-600 rounded-full shadow-sm backdrop-blur-sm">
          {category}
        </span>
      </div>
    </div>

    <div className="p-8">
      <h2 className="text-md text-gray-700">
        {title}
      </h2>

      <div className="space-y-6">
        <div className="pb-3 border-b border-gray-100">
          <p className="text-base font-semibold text-gray-900">{venue}</p>
          <div className="flex items-center text-gray-500">
            <i className="fas fa-location-dot mr-2 text-blue-500"></i>
            <p  className="mt-1 text-md text-gray-500">{location}</p>
          </div>
        </div>

        <div className="flex items-center justify-between pb-3 border-b border-gray-100">
          <div className="flex items-center text-gray-700">
            <div className="w-10 h-10 rounded-full bg-blue-50 flex items-center justify-center mr-3">
              <i className="fas fa-calendar-alt text-blue-500"></i>
            </div>
            <div>
              <p className="text-base font-semibold text-gray-900">{date}</p>
              <p className="text-sm text-gray-500">{time}</p>
            </div>
          </div>

        </div>

        <div className="pt-2">
          {/* <button
            onClick={onRSVP}
            className="rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-xs hover:bg-indigo-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          >
            RSVP Now
          </button> */}
        </div>
      </div>
    </div>
  </div>
  );
};

  function StoryComponent() {
    return (
      <div className="p-8 space-y-8">
        <div>
          <h2 className="text-xl font-bold mb-4">Default Event Card</h2>
          <MainComponent />
        </div>

        <div>
          <h2 className="text-xl font-bold mb-4">Event Card with Custom Data</h2>
          <MainComponent
            title="Annual Alumni Gala"
            date="2025-03-15"
            time="7:00 PM"
            location="Grand Ballroom, Alumni Center"
            description="Join us for an evening of celebration, networking, and reminiscing with fellow alumni. Dinner and entertainment included."
            imageUrl="/gala-event.jpg"
            attendeeCount={75}
            maxAttendees={100}
          />
        </div>

        <div>
          <h2 className="text-xl font-bold mb-4">Fully Booked Event</h2>
          <MainComponent
            title="Career Workshop"
            date="2025-02-01"
            time="2:00 PM"
            location="Virtual Event"
            description="Learn from industry experts about career advancement opportunities and professional development."
            imageUrl="/workshop.jpg"
            attendeeCount={50}
            maxAttendees={50}
          />
        </div>

        <div>
          <h2 className="text-xl font-bold mb-4">RSVPed Event</h2>
          <MainComponent
            title="Homecoming Game"
            date="2025-10-15"
            time="3:00 PM"
            location="University Stadium"
            description="Don't miss the biggest game of the year! Come support your alma mater and reconnect with old friends."
            imageUrl="/homecoming.jpg"
            attendeeCount={200}
            maxAttendees={500}
            isRSVPed={true}
          />
        </div>
      </div>
    );
  }


